export const TRANSACTION_LIST_REQUESTING =
	'transaction/TRANSACTION_LIST_REQUESTING';
export const TRANSACTION_LIST_SUCCESS = 'transaction/TRANSACTION_LIST_SUCCESS';
export const TRANSACTION_LIST_ERROR = 'transaction/TRANSACTION_LIST_ERROR';

export const SET_OPTIONAL_FIELD = 'transaction/SET_OPTIONAL_FIELD';

export const SET_FILTER = 'transaction/SET_FILTER';
export const REQUEST_PENDING = 'transaction/REQUEST_PENDING';
export const SEARCH = 'transaction/SEARCH';
export const RESET_TRANSACTIONS = 'transaction/RESET';
